import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, useAuth } from "../App";
import UserAutocomplete from "../components/UserAutocomplete";
import { ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function CreateProjectPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ title: "", description: "", assigned_to: "", sub_assigned_to: "", reviewer_1: "", reviewer_2: "", due_date: "", start_date: "" });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.title.trim() || !form.assigned_to) { toast.error("Title and Assigned To required"); return; }
    setSubmitting(true);
    try {
      await api.post("/projects", {
        ...form,
        assigned_to: form.assigned_to,
        sub_assigned_to: form.sub_assigned_to || null,
        reviewer_1: form.reviewer_1 || null,
        reviewer_2: form.reviewer_2 || null,
        due_date: form.due_date || null,
        start_date: form.start_date || null,
      });
      toast.success("Project created");
      navigate("/me");
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
    finally { setSubmitting(false); }
  };

  return (
    <>
      
      <div>
        <div className="max-w-lg mx-auto space-y-5">
          <div className="flex items-center gap-3">
            <button onClick={() => navigate("/me")} className="p-2 text-[var(--t3)] hover:text-[var(--t1)]"><ArrowLeft size={20} /></button>
            <h1 className="font-heading text-2xl text-[var(--t1)]">NEW PROJECT</h1>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div><label className="text-[var(--t3)] text-xs mb-1 block">Title *</label>
              <input value={form.title} onChange={(e) => setForm({...form, title: e.target.value})} placeholder="Project name" className="form-input" required />
            </div>
            <div><label className="text-[var(--t3)] text-xs mb-1 block">Description</label>
              <textarea value={form.description} onChange={(e) => setForm({...form, description: e.target.value})} placeholder="What's this project about?" rows={3} className="form-input resize-none" />
            </div>
            <UserAutocomplete value={form.assigned_to} onChange={(v) => setForm({...form, assigned_to: v})} label="Assigned To" placeholder="Primary owner..." required />
            <UserAutocomplete value={form.sub_assigned_to} onChange={(v) => setForm({...form, sub_assigned_to: v})} label="Sub Assigned To" placeholder="Secondary support (optional)" />
            <UserAutocomplete value={form.reviewer_1} onChange={(v) => setForm({...form, reviewer_1: v})} label="Reviewer 1" placeholder="Approval owner (optional)" />
            <UserAutocomplete value={form.reviewer_2} onChange={(v) => setForm({...form, reviewer_2: v})} label="Reviewer 2" placeholder="Backup reviewer (optional)" />
            <div className="grid grid-cols-2 gap-3">
              <div><label className="text-[var(--t3)] text-xs mb-1 block">Start Date</label>
                <input type="date" value={form.start_date} onChange={(e) => setForm({...form, start_date: e.target.value})} className="form-input" />
              </div>
              <div><label className="text-[var(--t3)] text-xs mb-1 block">Due Date</label>
                <input type="date" value={form.due_date} onChange={(e) => setForm({...form, due_date: e.target.value})} className="form-input" />
              </div>
            </div>
            <button type="submit" disabled={submitting} className="w-full py-3 bg-[var(--r)] text-white font-bold rounded-xl hover:bg-[var(--r)] transition-colors disabled:opacity-50">
              {submitting ? "Creating..." : "Create Project"}
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
